<template>
  <div>
    <div>
      <div class="common-title">填写清晰的项目卖点，帮助顾问更准确sell职位。【非必填信息】</div>
      <el-row :gutter="20" style="padding-bottom:10px;border-bottom:1px solid #e2e2e2">
        <el-col :span="14">
          <el-row type="flex" align="center" style="margin-bottom:10px;align-items:center">
            <div style="margin-right:10px;font-size:16px">公司亮点及优势</div>
            <p class="common-tips">（常用标签，可以快速点选）</p>
          </el-row>
          <el-row type="flex" align="center" style="margin-bottom:10px">
            <el-tag
              size="mini"
              :effect="value?'dark':'plain'"
              style="margin-right:5px;cursor:pointer"
              type="primary"
              v-for="(value,key) in 公司亮点.keywords"
              :key="key"
              @click="addHeighLight(key)"
            >{{key}}</el-tag>
          </el-row>
          <el-input
            type="textarea"
            placeholder="请输入公司亮点及优势"
            @change="inputChange"
            v-model="project.公司亮点及优势"
            :rows="4"
          ></el-input>
        </el-col>
        <el-col :span="10">
          <p class="common-tips">1、公司亮点会自动联动到此处，可以根据项目具体情况更改</p>
          <p class="common-tips">2、如果亮点有变动可以自行选择是否返回公司信息</p>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="padding:10px 0;">
        <el-col :span="14">
          <el-row type="flex" align="center" style="margin-bottom:10px">
            <div style="margin-right:10px;font-size:16px">项目亮点及优势</div>
          </el-row>
          <el-input type="textarea" placeholder="请输入项目亮点及优势" :rows="4" v-model="project.项目亮点及优势"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="padding:10px 0;border-bottom:1px solid #e2e2e2">
        <el-col :span="14">
          <el-row type="flex" align="center" style="margin-bottom:10px" :gutter="20">
            <el-col style="font-size:16px" :span="4">用人部门</el-col>
            <el-col :span="20">
              <el-input size="mini" placeholder="请输入部门名称" v-model="project.部门"></el-input>
            </el-col>
          </el-row>
          <el-row type="flex" align="center" style="margin-bottom:10px;font-size:16px">部门详情</el-row>
          <el-input type="textarea" placeholder="请填写用人部门的情况,以推动候选人" v-model="project.部门详情" style="margin-bottom:10px;"></el-input>
           <el-row type="flex" align="center" style="margin-bottom:10px;font-size:16px">可能的问题及应对</el-row>
          <el-input type="textarea" placeholder="请填写可能的问题及应对" v-model="project.可能的问题及应对"></el-input>
        </el-col>
        <el-col :span="10"></el-col>
      </el-row>
      <el-row :gutter="20" style="padding:10px 0;">
        <el-col :span="14">
          <el-row type="flex" align="center" style="margin-bottom:10px">
            <div style="margin-right:10px;font-size:16px">阿尔法认知</div>
          </el-row>
          <el-input type="textarea" placeholder="请填写阿尔法内部顾问对于该客户或项目的评价" v-model="project.阿尔法认知"></el-input>
        </el-col>
        <el-col :span="10">
          <p class="common-tips">1、客户公司阿尔法认知会联动到此处，可以根据项目具体情况自行更改；</p>
        </el-col>
      </el-row>
    </div>
    <div class="handle-buttons">
      <el-button size="mini" type="primary" @click="next">下一步</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    project: { type: Object, default: () => ({}) },
    activeCarousel: Object
  },
  data () {
    return {
      公司亮点: {
        content: "",
        keywords: { "股东实力强": false, "大平台": false, "固薪高": false, "激励机制好": false, "文化好": false, "人员整体素质高": false, "压力小": false, "稳定": false }
      },
      companyId: "",
      companyData: null,
      ifChange: false
    }
  },
  watch: {
    project: {
      async handler (newVal) {
        if (!newVal.客户公司 || this.companyData) return
        const { result } = await app.service("company").getCompany(newVal.客户公司)
        this.companyId = result._id
        this.companyData = result
        this.公司亮点 = result.公司亮点 || {
          content: "",
          keywords: { "股东实力强": false, "大平台": false, "固薪高": false, "激励机制好": false, "文化好": false, "人员整体素质高": false, "压力小": false, "稳定": false }
        }
        this.project.公司亮点及优势 = result.公司亮点 ? result.公司亮点.content : ""
        this.project.阿尔法认知 = result.公司备注
      },
      deep: true,
      immediate: true
    },
    activeCarousel () {
      this.ifChange = false
    }
  },
  methods: {
    inputChange () {
      this.ifChange = true
    },
    next () {
      if (this.ifChange) {
        this.$confirm('公司亮点已经更改，是否联动到该客户公司？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.公司亮点.content = this.project.公司亮点及优势
          app.service("company").modifyCompany({ query: { _id: this.companyId }, data: { 公司亮点: this.公司亮点 } })
          this.$emit('next')
        }).catch(() => {
          this.$emit('next')
        });
      } else {
        this.$emit('next')
      }
    },
    addHeighLight (item) {
      this.公司亮点.keywords[item] = !this.公司亮点.keywords[item]
      this.ifChange = true
    }
  }
}
</script>
<style src="../../../statistics/css/addProject.css"></style>
